import { useGmailIgnoredRecent } from '../../hooks/queries/useGmailInbox';
import { GmailMessageCard } from './GmailMessageCard';

const REASON_LABEL: Record<string, string> = {
  sender_not_client: 'Expéditeur inconnu',
  internal_sender: 'Mail interne au cabinet',
  manual_dismiss: 'Ignoré manuellement',
  attachment_too_large: 'Pièce jointe trop volumineuse',
};

export function GmailInboxIgnoredTab() {
  const { data, isLoading } = useGmailIgnoredRecent();
  if (isLoading) return <div className="p-4 text-gray-500">Chargement…</div>;
  if (!data || data.length === 0) {
    return <div className="p-8 text-center text-gray-500">Aucun mail ignoré ces 7 derniers jours.</div>;
  }
  return (
    <div className="space-y-3">
      {data.map((m) => (
        <GmailMessageCard
          key={m.id!}
          fromName={m.from_name}
          fromEmail={m.from_email!}
          subject={m.subject}
          internalDate={m.internal_date!}
          badge={
            <span className="inline-block px-2 py-0.5 text-xs bg-gray-100 text-gray-700 rounded">
              {REASON_LABEL[m.ignored_reason ?? ''] ?? m.ignored_reason}
            </span>
          }
          actions={
            <div className="text-xs text-gray-500">
              (Création de contact + rattachement : itération suivante)
            </div>
          }
        />
      ))}
    </div>
  );
}
